module.exports = __webpack_public_path__ + "static/media/locksmit.765be050.jpg";